'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'umbrella-beach';
var width = 576;
var height = 512;
var aliases = [127958];
var unicode = 'f5ca';
var svgPathData = 'M568.9 301.7c-.9 5.3-1.9 10.6-3.1 15.9l-15.2-5.5-108-39.3s0 0 0 0l-15-5.5L229.9 195.4l-15-5.5s0 0 0 0L103.6 149.4l-15.2-5.5c2.5-4.8 5.1-9.6 7.8-14.2C157.2 27.2 283.5-21.4 399.8 18.9c.9 .3 1.7 .6 2.6 .9l5.9 2.1c2.5 .9 5 1.9 7.4 3c110 46.3 172 161.9 153.2 276.8zM394.7 34c-30-9.9-63.2-1.7-85 21.4c-30.9 32.6-54.7 71.3-70.1 113.5l-4.1 11.4 197.7 71.9 4.2-11.4c15.4-42.2 21.9-87.1 19.3-132c-1.8-30.2-20.1-56.7-47.2-69.3c-3.6-1.5-7.3-3-11-4.3c-1.2-.4-2.4-.9-3.6-1.3zM331.8 21.3c-88.1-5.8-173.6 37.9-220.2 114l108.8 39.6 4.1-11.4c16.1-44.3 41.1-84.8 73.5-119c9.7-10.2 21.2-18 33.7-23.2zM448.1 257.8l105.5 38.4c13-86.5-22.7-173-91-225.6c5.7 11.5 9.1 24.1 9.9 37.4c2.8 47-4.1 94.1-20.2 138.4l-4.1 11.4zM8 496l214.1 0 1.8-4.9 84.8-233 15 5.5L239.1 496 568 496l8 0 0 16-8 0L8 512l-8 0 0-16 8 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faUmbrellaBeach = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;